import { Component, OnInit } from '@angular/core';
import { Ingredient } from '../../models/ingredient.model';
import { ConnectionService } from '../../services/connection.service';

@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.css']
})
export class NewProduct implements OnInit {
  ingredients: Ingredient[]

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  item_products: any = {
    name: '',
    ingredient_id: []
  }

  constructor(private connection: ConnectionService) { }

  ngOnInit() {
    this.connection.getIngredients()
    .subscribe(data => this.ingredients = data)

    /*
    testing local
    this.dropdownList = [
      { item_id: 1, item_text: 'Mumbai' },
      { item_id: 2, item_text: 'Bangaluru' },
      { item_id: 3, item_text: 'Pune' },
      { item_id: 4, item_text: 'Navsari' },
      { item_id: 5, item_text: 'New Delhi' }
    ];
    this.selectedItems = [
      { item_id: 3, item_text: 'Pune' },
      { item_id: 4, item_text: 'Navsari' }
    ];
    */

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true
    };
  }

  add() {
    this.connection.addProduct(this.item_products)
    this.item_products.name = '';
  }
  onItemSelect(item: any) {
    //debo pasarle el item.item_id al modelo item_products
    this.item_products.ingredient_id.push(item.id)
  }
  onSelectAll(items: any) {
    items.forEach(element => {
      this.item_products.ingredient_id.push(element.id)
    });
    console.log(this.item_products)
  }
  onDeSelect(item: any){
    //eliminar el item de modelo modelo item_products
    this.item_products.ingredient_id.pop(item.id)
  }
  onDeSelectAll(items: any){
    this.item_products.ingredient_id = []
    console.log(this.item_products.ingredient_id)
  }
}
